

















































































































































































































































import { Component, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
/* api */
import GroupListApi from '@/app/model/api/groupListApi'
import GroupEditApi from '@/app/model/api/groupEditApi'
import GroupDeleteApi from '@/app/model/api/groupDeleteApi'
/* module */
import CommonClass from '@/app/module/common'
import Validator from '@/app/module/validator'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    Loading,
    Error409Modal,
    ErrorModal,
    ErrorInfo,
    DeleteModal
  }
})
export default class GroupCreate extends Vue {
  private groupId: string = ''
  private id: string = ''
  private timeStamp: number = 0
  private groupData: any = {}
  private group: string = ''
  private isViewingRestriction: boolean = false
  private errorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  private status: any = [
    { text: '公開', value: false },
    { text: '非公開', value: true }
  ]
  /* 表示非表示 */
  private showLoading: boolean = true
  private showServerErrorModal: boolean = false
  private showConfirmationModal: boolean = false
  private showError409Modal: boolean = false
  private show400ErrorMessage: boolean = false

  created () {
    this.groupId = this.$route.params.group_id
    this.getGroupList()
  }

  private getGroupList () {
    (async () => {
      const result = await GroupListApi.getGroupList('')

      if (result.isOk()) {
        this.groupData = result.getPayload().groups

        for (var i in this.groupData) {
          if (this.groupData[i].group_id === parseInt(this.groupId)) {
            this.group = this.groupData[i].group_name
            this.isViewingRestriction = this.groupData[i].is_viewing_restriction
            this.id = this.groupData[i].group_id
            this.timeStamp = this.groupData[i].time_stamp
          }
        }

        // 存在しないユーザーを直接指定した場合は404ページへ遷移
        if (this.id === '') {
          this.$store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_DEFAULT)
          this.$router.push(routerPath.PATH_ERROR_PAGE).catch(e => {})
        }

        this.showLoading = false
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  private async groupEdit () {
    if (!this.isGroupEdit()) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      return
    } else {
      this.show400ErrorMessage = false
    }

    const bodyData = {
      group_name: this.group,
      is_viewing_restriction: this.isViewingRestriction,
      time_stamp: this.timeStamp
    }

    const result = await GroupEditApi.doGroupEdit(this.$route.params.group_id, bodyData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: 'グループ編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/group').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  /* バリデーション */
  private isGroupEdit () {
    const groupNameFlag = Validator.validateInputGroupName('groupNameErrorMessage', this.group)
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    return groupNameFlag
  }

  /* グループ削除 */
  private doGroupDelete () {
    (async () => {
      const result = await GroupDeleteApi.doGroupDelete(this.$route.params.group_id.toString())

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: 'グループを削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/master/group').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showConfirmationModal = false
    })()
  }

  private doCancel () {
    this.$router.push('/master/group').catch(e => {})
  }
}
